import { defineStore } from "pinia";
import { computed } from "vue";
import { t } from "@/i18n";
import { LayoutHorizontal3Icon, LayoutHorizontal4Icon, LayoutSliderIcon } from "@easy/ui/icons";
import { makeLogger } from "@/shared/consola";
import SvgCookieLayoutModal from "@/apps/cookie/project/onboarding/svg-previews/SvgCookieLayoutModal.vue";
import SvgCookieLayoutBanner from "@/apps/cookie/project/onboarding/svg-previews/SvgCookieLayoutBanner.vue";
import SvgCookieLayoutPopup from "@/apps/cookie/project/onboarding/svg-previews/SvgCookieLayoutPopup.vue";
import { useOnboarding } from "@/shared/projects/onboarding/useOnboarding";
import { useActions, useMutations, useState } from "@/store/vuex-composition-mappers";
import { mapThemeToCookieColors } from "@/shared/projects/prepare-theme";

const STORE_NAME = "cookie-creator";
const logger = makeLogger("🍍" + STORE_NAME);

// {state}.cookie.type:
const COOKIE_LAYOUT_TYPES = {
    modal: "modal",
    banner: "banner",
    popup: "popup",
};

export const useCookieCreatorStore = defineStore(STORE_NAME, () => {
    logger.trace("👋hello");

    const { cookie } = useState("cookie", ["cookie"]);
    const { saveSnapshot } = useActions("cookie", ["saveSnapshot"]);
    const { showAlert } = useMutations(["showAlert"]);

    const {
        isCreatorShown,
        onboardState,
        previewCssVars,
        autoOpenCreator,
        toggleCreatorShown,
        updateProductInfo,
        validate,
    } = useOnboarding();

    onboardState.layout = COOKIE_LAYOUT_TYPES.modal;

    const templates = computed(() => []);

    const layouts = computed(() => [
        {
            label: t("cookie.layout.modal"),
            value: COOKIE_LAYOUT_TYPES.modal,
            info: t("cookie.layout.modal_info"),
            icon: LayoutHorizontal3Icon,
            preview: SvgCookieLayoutModal,
        },
        {
            label: t("cookie.layout.banner"),
            value: COOKIE_LAYOUT_TYPES.banner,
            info: t("cookie.layout.banner_info"),
            icon: LayoutSliderIcon,
            preview: SvgCookieLayoutBanner,
        },
        {
            label: t("cookie.layout.popup"),
            value: COOKIE_LAYOUT_TYPES.popup,
            info: t("cookie.layout.popup_info"),
            icon: LayoutHorizontal4Icon,
            preview: SvgCookieLayoutPopup,
        },
    ]);

    const previewComponent = computed(
        () => layouts.value.find((l) => l.value === onboardState.layout)?.preview
    );

    return {
        onboardState,
        isCreatorShown,
        templates,
        layouts,
        previewCssVars,
        previewComponent,
        links: computed(() => ({
            video: "",
            docs: "",
        })),
        autoOpenCreator,
        onboardingAction(resolveResponse) {
            return async () => {
                // if (!validate()) {
                //     return;
                // }
                try {
                    onboardState.isLoading = true;
                    const response = await resolveResponse();
                    const { theme, layout } = onboardState;
                    logger.debug("about to fillWithExample", { response, theme, layout });
                    cookie.value.type = layout;
                    for (const [key, value] of Object.entries(mapThemeToCookieColors(theme))) {
                        cookie.value[key] = value;
                    }
                    showAlert({
                        type: "success",
                        title: t("shared.creator.generation_success"),
                    });
                    await saveSnapshot();
                    toggleCreatorShown(false);
                } catch (e) {
                    logger.error(e);
                } finally {
                    onboardState.isLoading = false;
                }
            };
        },
        toggleCreatorShown,
        updateProductInfo,
        validate,
    };
});
